module.exports = __webpack_public_path__ + "static/media/nodejs-dark.e11ed407.png";